import React from 'react';
import { Box, Button, Container, Grid, Typography, Stack, Link } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import ExploreOutlined from '@mui/icons-material/ExploreOutlined';
import DomainOutlined from '@mui/icons-material/DomainOutlined';
import HandshakeOutlined from '@mui/icons-material/HandshakeOutlined';

import { LandingCard, LandingReveal, landingCaptionSx } from './LandingMotion';

const offers = [
  {
    name: 'Explore',
    price: 'Free',
    tone: 'done',
    mark: ExploreOutlined,
    body: 'Create and try Decision Games and Decision Moments.',
  },
  {
    name: 'Organizations',
    price: 'Annual plans, quoted',
    tone: 'ready',
    mark: DomainOutlined,
    body:
      'Create and reuse Decision Games from business context and approved knowledge. Facilitated and individual learning; hosted sessions included. Simulations stay later.',
  },
  {
    name: 'Expert partners',
    price: 'Custom agreement',
    tone: 'ready',
    mark: HandshakeOutlined,
    body:
      'Use your expertise to build Decision Games for client programs. Commercial rights and delivery scope are agreed with each partner.',
  },
];

const PricingOffers = () => {
  const { loginWithRedirect } = useAuth();

  const handleSignup = () => {
    loginWithRedirect({
      authorizationParams: {
        screen_hint: 'signup',
        prompt: 'consent',
        scope: 'openid profile email offline_access',
        audience: process.env.REACT_APP_AUDIENCE,
      },
    });
  };

  return (
    <Box
      id="pricing"
      component="section"
      sx={{
        bgcolor: 'background.paper',
        py: { xs: 8, md: 12 },
        borderTop: '1px solid',
        borderColor: 'divider',
        scrollMarginTop: 88,
      }}
    >
      <Container maxWidth="lg">
        <LandingReveal>
          <Typography variant="caption" sx={landingCaptionSx}>
            Pricing
          </Typography>
          <Typography
            component="h2"
            sx={{
              mt: 1,
              mb: 1.5,
              fontWeight: 600,
              fontSize: { xs: '1.75rem', md: '2.25rem' },
              letterSpacing: '-0.02em',
              maxWidth: 560,
            }}
          >
            Explore free. Organizations subscribe.
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 5, maxWidth: 560 }}>
            Annual access is quoted for your scope.
          </Typography>
        </LandingReveal>

        <Grid container spacing={2.5} sx={{ mb: 5 }}>
          {offers.map((offer, index) => (
            <Grid
              item
              xs={12}
              sm={offer.name === 'Explore' ? 12 : 6}
              key={offer.name}
              sx={{ display: 'flex' }}
            >
              <LandingReveal index={index} sx={{ width: '100%', height: '100%' }}>
                <LandingCard
                  kind="price"
                  mark={offer.mark}
                  tone={offer.tone}
                  title={offer.name}
                  label={offer.price}
                  body={offer.body}
                  titleComponent="h3"
                />
              </LandingReveal>
            </Grid>
          ))}
        </Grid>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1.5}
          justifyContent="left"
        >
          <Button variant="contained" size="large" onClick={handleSignup}>
            Sign up for free trial
          </Button>
          <Button
            variant="outlined"
            size="large"
            component="a"
            href="mailto:info@itclarifies.com?subject=Organization%20pilot"
          >
            Request a quote
          </Button>
        </Stack>
        

        <Typography variant="body2" color="text.secondary" sx={{ mt: 3, maxWidth: 560 }}>
          Professional services are quoted separately.{' '}
          <Link href="mailto:info@itclarifies.com" underline="hover" color="primary.dark">
            Contact Itclarifies
          </Link>
          .
        </Typography>
      </Container>
    </Box>
  );
};

export default PricingOffers;
